import { render, staticRenderFns } from "./DangerZone.vue?vue&type=template&id=00b16ea0&scoped=true"
import script from "./DangerZone.vue?vue&type=script&lang=js"
export * from "./DangerZone.vue?vue&type=script&lang=js"
import style0 from "./DangerZone.vue?vue&type=style&index=0&id=00b16ea0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b16ea0",
  null
  
)

export default component.exports